export const isEnumValue = <T extends Record<string, any>>(e: T, value: any): value is T[keyof T] => {
    return Object.values(e).includes(value);
};
